import {
  AbstractSearchCore,
  AbstractSubscriber,
  IFacet,
  IMultipleResults,
  ISearchConfig,
} from '../../modules/search'
import MainModule from '../../modules/main'
import { config } from '../../constants'

class PlacesAutocompleteSubscriber extends AbstractSubscriber {
  private _searchCore: AbstractSearchCore | null = null

  constructor() {
    super('placesSearch')
  }

  public detaching() {}

  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this._searchCore = searchCore
  }

  public async onSearchTextUpdate(text: string): Promise<void> {}

  public async onFacetUpdate(facets: IFacet[]): Promise<void> {}

  public async onResultUpdate(result: IMultipleResults): Promise<void> {}

  public async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {}

  public async getSuggestions(text: string) {
    await this.whenReady()

    if (!this._searchCore) {
      return []
    }

    const result = await this._searchCore.executeSearch({
      query: text,
      facets: config.searchConfigs.searchCoreConfigs.placesSearch.defaultFacets,
    } as ISearchConfig)
    return result?.places_full?.items || []
  }

  public async whenReady(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this._searchCore) {
        resolve(true)
      } else {
        let interval = setInterval(() => {
          if (this._searchCore) {
            clearInterval(interval)
            resolve(true)
          }
        }, 10)
      }
    })
  }
}

export class PlacesAutocomplete {
  private static _instance: PlacesAutocomplete
  public static get instance(): PlacesAutocomplete {
    return this._instance || (this._instance = new this())
  }

  private _subscriberInstance: PlacesAutocompleteSubscriber = new PlacesAutocompleteSubscriber()

  constructor() {
    this.init()
  }

  private async init() {
    MainModule.getInstance().getSearchManager().subscribe(this._subscriberInstance)
  }

  public async whenReady(): Promise<boolean> {
    return this._subscriberInstance.whenReady()
  }

  public async getSuggestions(text: string) {
    return this._subscriberInstance.getSuggestions(text)
  }
}
